import { alpha, keyframes, type Theme } from "@mui/material/styles";

export const appSkeletonShimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
`;

export function getAppSkeletonBaseStyles(theme: Theme) {
  return {
    position: "relative",
    overflow: "hidden",
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: `linear-gradient(90deg, transparent 0%, ${alpha(theme.palette.background.paper, 0.74)} 50%, transparent 100%)`,
      animation: `${appSkeletonShimmer} 1.6s ease-in-out infinite`,
    },
  } as const;
}
